import { useEffect, useRef, useState } from 'react';
import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ModelOfContrato } from 'src/database/index';

import { useAuth } from 'src/contexts/auth';
import api from 'src/services/api';

interface ContratoCpfProps {
  NOME: string;
  DATANASCIMENTO: string;
}

export const useFormCreateContrato = () => {
  const { userAgencyId } = useAuth();
  const [loading, setLoading] = useState(false);
  const [ContratoCpf, setContratoCpf] = useState<ContratoCpfProps[]>([{ NOME: '', DATANASCIMENTO: '' }]);
  const [contratoResponse, setContratoResponse] = useState<AxiosResponse | null>(null);
  const [contratoEditedResponse, setContratoEditedResponse] = useState<AxiosResponse | null>(null);

  const toast: any = useRef();

  const validationSchema = Yup.object().shape({
    ORGAO: Yup.string(),
    DATAINICIO: Yup.string(),
    DATAFIM: Yup.string(),
    NUMERO: Yup.string(),
    TAXAADM: Yup.number(),
    DESCRICAO: Yup.string(),
    VALOR: Yup.number().nullable(),
  });

  const saveContrato = (Contrato: ModelOfContrato) => {
    setLoading(true);

    const newContrato: ModelOfContrato = {
      ...Contrato,
      ORGAO: userAgencyId,
    };
    console.log("newContrato", newContrato)
    if (!!contratoResponse) {
      api.put(`contratos/${contratoResponse.data.ID}`, newContrato)
        .then((response) => {
          formik.resetForm();
          setContratoEditedResponse(response);
          setContratoResponse(null);
          setLoading(false);
          toast.current.show({ severity: 'success', summary: 'Edição realizada', detail: 'O credor foi editado com sucesso!', life: 5000 });
        }).catch((err) => {
          console.log(err);
          setLoading(false);
          toast.current.show({ severity: 'error', summary: 'Edição não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
        })
    } else {
      console.log("newContrato:", newContrato)
      api.post('/contratos', newContrato)
        .then((response) => {
          setContratoResponse(response);
          setContratoEditedResponse(null);
          setLoading(false);
          toast.current.show({ severity: 'success', summary: 'Cadastro realizado', detail: 'Operação realizada com sucesso!', life: 5000 });
        }).catch((err) => {
          console.log(err);
          setLoading(false);
          toast.current.show({ severity: 'error', summary: 'Cadastro não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
        });
    }
  };

  const formik = useFormik<ModelOfContrato>({
    initialValues: {
      ORGAO: '',
      ID: '',
      DATAINICIO: '',
      DATAFIM: '',
      NUMERO: '',
      TAXAADM: 0,
      DESCRICAO: '',
      VALOR: 0,
    },
    onSubmit: async values => await saveContrato(values),
    validationSchema
  });




  return {
    getContratoFormController: {
      formik,
      loading,
      ContratoCpf,
      toast,
      contratoResponse,
      contratoEditedResponse
    },
    handleContratoFormController: {
      setContratoResponse,
      setContratoEditedResponse
    }
  };
};